@use '@design/design-tokens/typography/typography' as *;

.iconWrapper {
  display: flex;
}

.sun {
  fill: var(--icon-success);
}

.sunRise {
  fill: var(--icon-primary);
}

.moon {
  fill: var(--icon-soft);
}

.dateContainer {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-nort);

  [data-tooltip-bubble] {
    padding: 4px 8px;
  }
}

.timeLabel {
  @include typography-v2-body-sm;
  color: var(--text-default);
}
